import gql from "graphql-tag";

/**
 * The other reports of this site this one can be compared with.
 *
 * Reports crawled before page content was stored, or under different
 * extraction settings, cannot be compared and are left out — offering them
 * would only lead to a screen explaining why there is nothing to show.
 */
export const COMPARABLE_CRAWLS = gql`
  query ComparableCrawls($sessionId: String!) {
    ComparableCrawls(sessionId: $sessionId)
  }
`;

/**
 * Every url in a crawl and what happened to it since another crawl.
 *
 * Both sides are named, so any two reports of a site can be compared rather
 * than only consecutive ones. Returns counts and a page of urls with their
 * status; the diff for a single page is fetched separately when it is opened.
 *
 * `compareTo` is optional: without it there is no second report to compare
 * against, and every page comes back with status `not-compared` instead of
 * the query being refused.
 */
export const CRAWL_DIFF = gql`
  query CrawlDiff($sessionId: String!, $compareTo: String, $status: String, $search: String, $limit: Int, $offset: Int) {
    CrawlDiff(sessionId: $sessionId, compareTo: $compareTo, status: $status, search: $search, limit: $limit, offset: $offset)
  }
`;

/**
 * What changed inside one page: the line-by-line difference, the audited
 * fields that moved, and the issues it gained or lost.
 */
export const PAGE_DIFF = gql`
  query PageDiff($sessionId: String!, $url: String!, $compareTo: String) {
    PageDiff(sessionId: $sessionId, url: $url, compareTo: $compareTo)
  }
`;
